<template>
  <WidgetKpiCard
    :error="!!error"
    :loading="loading"
    :lastUpdate="lastUpdate"
    @click:refresh="refresh"
    @click:table="showTable"
  >
    <template #title>
      {{ $t("widgets.turnover.title") }}
    </template>

    <template v-if="data" #main>
      <KpiMain
        :value="data.main.value"
        :format="abbreviateNumber"
        :title="dateNames.year"
        @click="onMainKpiClick"
      ></KpiMain>
    </template>

    <template v-if="data" #subs>
      <KpiSub
        :title="$t('widgets.common.today')"
        :value="data.subs.day.value"
        :format="abbreviateNumber"
        :delta="data.subs.day.delta"
      ></KpiSub>
      <KpiSub
        :title="$t('widgets.common.week')"
        :value="data.subs.week.value"
        :format="abbreviateNumber"
        :delta="data.subs.week.delta"
      ></KpiSub>
      <KpiSub
        :title="dateNames.month"
        :value="data.subs.month.value"
        :format="abbreviateNumber"
        :delta="data.subs.month.delta"
      ></KpiSub>
    </template>
  </WidgetKpiCard>
</template>
<script>
import { endOfYear, startOfYear } from "date-fns";
import { inject } from "vue-demi";

import { useWidgetApi } from "@/composables/api/widget";
import { useRouter } from "@/composables/router";
import { usePeriodNames } from "@/composables/date";

import WidgetKpiCard from "./WidgetKpiCard.vue";
import KpiSub from "./WidgetKpiCard/KpiSub.vue";
import KpiMain from "./WidgetKpiCard/KpiMain.vue";
import { formatDate } from "@/utils/date";

export default {
  components: { WidgetKpiCard, KpiSub, KpiMain },

  props: {
    hover: {
      type: Boolean,
      default: false
    }
  },

  setup() {
    const { data, lastUpdate, loading, error, execute } = useWidgetApi(
      "/dashboard/turnover"
    );

    const router = useRouter();

    const showTable = () => {
      router.push({
        name: "DashboardTable",
        query: { measure: "turnover" }
      });
    };

    const showOnMap = inject("showOnMap");

    const onMainKpiClick = () => {
      showOnMap({
        measure: "turnover",
        date_from: formatDate(startOfYear(new Date())),
        date_to: formatDate(endOfYear(new Date()))
      });
    };

    const dateNames = usePeriodNames();

    return {
      data,
      lastUpdate,
      loading,
      error,
      dateNames,

      refresh: execute,
      showTable,
      onMainKpiClick
    };
  }
};
</script>
<style></style>
